module.exports = __webpack_public_path__ + "static/media/food.9c322a01.png";